export default "__VITE_PUBLIC_ASSET__562e7167__"